<template>
    <HeadlessTransitionRoot
        appear
        :show="isOpen"
        as="template"
    >
        <HeadlessDialog
            as="div"
            class="relative z-50"
            @close="close"
        >
            <HeadlessTransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div class="fixed inset-0 bg-black bg-opacity-25">
                    <MouseFollower :hide-when-over-el="dialogPanelEl" />
                </div>
            </HeadlessTransitionChild>

            <div class="fixed bottom-0 left-0 top-0 w-screen overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-5 text-center">
                    <HeadlessTransitionChild
                        as="template"
                        enter="duration-300 ease-out"
                        enter-from="opacity-0 scale-95"
                        enter-to="opacity-100 scale-100"
                        leave="duration-200 ease-in"
                        leave-from="opacity-100 scale-100"
                        leave-to="opacity-0 scale-95"
                    >
                        <HeadlessDialogPanel class="w-full max-w-4xl rounded-2xl shadow-xl transition-all">
                            <form
                                ref="dialogPanelEl"
                                class="flex rounded-2xl bg-whitegray p-4 flex-col sm:flex-row sm:p-10"
                                @submit.prevent="onSubmit"
                            >

                                <div class="flex flex-col gap-4 flex-1 flex-grow">
                                    <h1 class="mb-2 w-full text-center font-medium text-2xl ">Вы хотите включить
                                        уведомления?</h1>

                                    <h3 class="mb-2">Мы будем уведомлять Вас о статусе заказа через push-уведомления в
                                        браузере</h3>

                                    <div>
                                        <SimpleButton
                                            class="mt-4 px-4 py-4 uppercase"
                                            @click="setNotifications(true)"
                                        >
                                            Да, включить
                                        </SimpleButton>

                                        <SimpleButton
                                            class="mt-4 ml-4 px-4 py-4 uppercase"
                                            theme="grey"
                                            @click="setNotifications(false)"
                                        >
                                            Нет, не надо
                                        </SimpleButton>
                                    </div>


                                </div>

                            </form>
                        </HeadlessDialogPanel>
                    </HeadlessTransitionChild>
                </div>
            </div>
        </HeadlessDialog>
    </HeadlessTransitionRoot>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useSetUserNotifications, useUser } from '~/composables/api/user'
import type { UserNotifications } from '~/interfaces/users'
import { useToast } from 'vue-toastification'
import MyToastError from '~/components/MyToastError.vue'

const emit = defineEmits(['close'])
const isOpen = ref(false)

const dialogPanelEl = ref<HTMLElement>()

const close = () => {
    emit("close")
    isOpen.value = false
}

const { data: user } = useUser((v) => {
    if (v.notifications.order_status.push == null) {
        isOpen.value = true
    }
})

const toast = useToast()
const { $FCMRequestPermission } = useNuxtApp()
const { mutate } = useSetUserNotifications()
const setNotifications = async (value) => {
    const notifications:UserNotifications = {
        order_status: {push: value}
    }
    mutate(notifications, {
        onSuccess: async () => {
            if (value) {
                let result
                if(Notification) {
                    result = await Notification.requestPermission()
                }

                $FCMRequestPermission(result == "granted").then((result) => {
                }).catch((err) => {
                    toast({
                            component: MyToastError,
                            props: {
                                title: 'Ошибка',
                                detail: err,
                            }
                        },
                        {
                            timeout: 6000
                        })
                })
            }
            emit("close")
            isOpen.value = false
        }
    })
}

</script>
